var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M290.702 89.207H112.507v102.631h178.195V89.208Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M191.356 96.468h-72.67v86.147h72.67V96.468ZM216.07 133.066c9.587 0 17.359-7.775 17.359-17.367 0-9.591-7.772-17.367-17.359-17.367-9.587 0-17.359 7.776-17.359 17.367 0 9.592 7.772 17.367 17.359 17.367ZM262.458 133.066c9.587 0 17.358-7.775 17.358-17.367 0-9.591-7.771-17.367-17.358-17.367s-17.359 7.776-17.359 17.367c0 9.592 7.772 17.367 17.359 17.367ZM216.07 175.256c9.587 0 17.359-7.775 17.359-17.366 0-9.592-7.772-17.367-17.359-17.367-9.587 0-17.359 7.775-17.359 17.367 0 9.591 7.772 17.366 17.359 17.366ZM262.458 175.256c9.587 0 17.358-7.775 17.358-17.366 0-9.592-7.771-17.367-17.358-17.367s-17.359 7.775-17.359 17.367c0 9.591 7.772 17.366 17.359 17.366Z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M216.07 125.217c5.254 0 9.513-4.261 9.513-9.518 0-5.256-4.259-9.517-9.513-9.517s-9.513 4.261-9.513 9.517c0 5.257 4.259 9.518 9.513 9.518ZM262.458 125.217c5.254 0 9.513-4.261 9.513-9.518 0-5.256-4.259-9.517-9.513-9.517s-9.513 4.261-9.513 9.517c0 5.257 4.259 9.518 9.513 9.518ZM216.07 167.407c5.254 0 9.513-4.261 9.513-9.517 0-5.257-4.259-9.518-9.513-9.518s-9.513 4.261-9.513 9.518c0 5.256 4.259 9.517 9.513 9.517ZM262.458 167.407c5.254 0 9.513-4.261 9.513-9.517 0-5.257-4.259-9.518-9.513-9.518s-9.513 4.261-9.513 9.518c0 5.256 4.259 9.517 9.513 9.517Z",
  fill: "#ECEFF0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M123.099 139.444h62.765M154.481 99.804v79.181",
  stroke: "#ECEFF0",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M361.019 7.672H194.396v106.85h166.623V7.672Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M227.054 16.404h-24.223v56.123h24.223V16.404ZM227.054 81.456h-24.223v24.235h24.223V81.456Z",
  fill: "#FF9650"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M309.924 32.496h-76.887v2.845h76.887v-2.845ZM309.924 27.491h-76.887v2.846h76.887V27.49ZM309.924 37.5h-76.887v2.845h76.887v-2.846ZM288.741 64.09h-55.704v2.845h55.704v-2.846ZM309.924 59.085h-76.887v2.846h76.887v-2.846Z",
  fill: "#D8D8D8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M273.148 68.995h-40.111v2.846h40.111v-2.846Z",
  fill: "#ECEFF0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M290.114 96.86h-57.077v2.846h57.077v-2.845ZM309.924 91.955h-76.887V94.8h76.887v-2.845ZM309.924 22.488h-76.887v2.845h76.887v-2.845ZM309.924 54.081h-76.887v2.846h76.887V54.08ZM309.924 86.853h-76.887v2.845h76.887v-2.845ZM309.924 17.484h-76.887v2.845h76.887v-2.845ZM309.924 48.98h-76.887v2.845h76.887v-2.846ZM309.924 81.849h-76.887v2.845h76.887v-2.845ZM297.077 101.865h-64.04v2.845h64.04v-2.845Z",
  fill: "#D8D8D8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M317.868 14.442v93.309",
  stroke: "#151415",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M355.625 81.554h-30.009v24.235h30.009V81.554ZM355.625 48.98h-30.009v24.234h30.009V48.98Z",
  fill: "#D8D8D8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M355.625 16.404h-30.009V40.64h30.009V16.404Z",
  fill: "#0C75D7"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M142.615 18.367H1v200.551h141.615V18.367Z",
  fill: "#455A64",
  stroke: "#000",
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M132.023 27.688H11.493v182.498h120.53V27.688Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M87.106 19.446H56.508L53.37 4.63C52.978 2.766 54.35 1 56.312 1h30.99c1.864 0 3.335 1.766 2.943 3.63l-3.139 14.816Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M112.899 35.832H30.715l8.533-22.273c.784-1.962 2.647-3.336 4.805-3.336h55.41c2.158 0 4.021 1.276 4.806 3.336l8.63 22.273Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M120.549 35.832H23.066v-2.846c0-3.14 2.55-5.69 5.688-5.69h86.205a5.694 5.694 0 0 1 5.688 5.69v2.846h-.098Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M48.859 111.088c-15.3 0-27.755 12.461-27.755 27.767 0 6.77 2.452 13.049 6.473 17.857l21.282-17.857v-27.767Z",
  fill: "#0C75D7",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M76.612 138.855c0-15.306-12.454-27.767-27.754-27.767v27.767h27.755Z",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M76.612 138.855H48.858l8.827 26.394c10.984-3.729 18.927-14.129 18.927-26.394Z",
  fill: "#FF9650",
  stroke: "#040001",
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M27.479 156.712c5.1 6.084 12.75 10.008 21.282 10.008 3.04 0 6.08-.49 8.826-1.471l-8.827-26.394-21.281 17.857Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m68.57 119.82 4.512-4.513h13.926M70.238 156.516h16.77",
  stroke: "#151415",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M87.008 117.269a1.962 1.962 0 1 0-.001-3.924 1.962 1.962 0 0 0 .001 3.924ZM87.008 158.478a1.961 1.961 0 1 0 0-3.923 1.961 1.961 0 0 0 0 3.923Z",
  fill: "#151415"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M122.608 111.873H93.383v6.77h29.225v-6.77ZM122.608 153.769H93.383v6.77h29.225v-6.77Z",
  fill: "#ECEFF0"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M118.587 147.882H97.404c-2.256 0-4.021-1.766-4.021-4.023V126.59c0-2.257 1.765-4.023 4.02-4.023h21.184c2.256 0 4.021 1.766 4.021 4.023v17.269c0 2.257-1.863 4.023-4.021 4.023ZM118.587 192.525H97.404c-2.256 0-4.021-1.766-4.021-4.023v-17.268c0-2.257 1.765-4.023 4.02-4.023h21.184c2.256 0 4.021 1.766 4.021 4.023v17.268c0 2.257-1.863 4.023-4.021 4.023Z",
  stroke: "#ECEFF0",
  strokeMiterlimit: 10
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M88.97 175.943H21.006v3.925H88.97v-3.925ZM88.97 182.125H21.006v3.924H88.97v-3.924ZM78.574 188.404H21.006v3.925h57.568v-3.925Z",
  fill: "#455A64"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M109.27 64.973h-81.3v7.358h81.3v-7.358Z",
  fill: "#ECEFF0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M122.51 59.478H21.006v37.285H122.51V59.478Z",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M27.97 61.342v33.753",
  stroke: "#151415",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M35.325 61.342v33.753M42.68 61.342v33.753M50.133 61.342v33.753M57.489 61.342v33.753M64.844 61.342v33.753M87.008 61.342v33.753M101.817 61.342v33.753M72.297 61.342v33.753M79.653 61.342v33.753M94.461 61.342v33.753M109.172 61.342v33.753M116.625 61.342v33.753",
  stroke: "#ECEFF0",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M81.908 74.883H27.97v7.358h53.94v-7.358Z",
  fill: "#455A64"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M38.56 84.792H27.97v7.359h10.59v-7.359Z",
  fill: "#FF9650"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M27.97 61.342v33.753",
  stroke: "#151415",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M85.047 42.21h-64.04v9.32h64.04v-9.32Z",
  fill: "#455A64"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M120.843 51.53h-11.572c-1.275 0-2.256-.98-2.256-2.256v-.197c0-1.275.981-2.256 2.256-2.256h11.572c1.275 0 2.256.981 2.256 2.257v.196c0 1.275-1.079 2.256-2.256 2.256Z",
  fill: "#0C75D7"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M198.515 239.817H75.535v30.417h122.98v-30.417Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M198.515 170.645H75.535v99.589h122.98v-99.589Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m84.165 200.276 8.826-5.004 8.826 7.261 8.729-2.944 8.826-2.158 8.827-3.434 8.826 11.479 8.826-6.279 8.827-10.303 8.826 24.235 8.827-5.985 8.826 3.14 8.728 13.835",
  stroke: "#455A64",
  strokeMiterlimit: 10
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M84.165 171.135v68.682M92.99 171.135v68.682M101.817 171.135v68.682M110.546 171.135v68.682M119.372 171.135v68.682M128.199 171.135v68.682M154.678 171.135v68.682M172.331 171.135v68.682M137.025 171.135v68.682M145.851 171.135v68.682M163.504 171.135v68.682M181.157 171.135v68.682M189.885 171.135v68.682",
  stroke: "#ECEFF0",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M85.831 198.608H82.4v3.434h3.432v-3.434ZM103.484 200.767h-3.432v3.434h3.432v-3.434ZM121.137 195.763h-3.432v3.434h3.432v-3.434ZM182.824 208.616h-3.432v3.434h3.432v-3.434ZM138.79 203.71h-3.433v3.434h3.433v-3.434ZM94.658 193.506h-3.432v3.434h3.432v-3.434ZM112.311 197.921h-3.433v3.434h3.433v-3.434ZM129.964 192.23h-3.433v3.434h3.433v-3.434ZM191.65 222.352h-3.432v3.434h3.432v-3.434ZM173.998 205.476h-3.433v3.434h3.433v-3.434ZM165.171 211.363h-3.432v3.434h3.432v-3.434ZM156.345 187.128h-3.433v3.434h3.433v-3.434ZM147.518 197.431h-3.432v3.434h3.432v-3.434Z",
  fill: "#455A64"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M198.515 170.645H75.535v99.589h122.98v-99.589Z",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M87.4 245.116h-3.922v3.924h3.923v-3.924Z",
  fill: "#455A64"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M83.478 253.848h3.923",
  stroke: "#0C75D7",
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M83.478 261.207h3.923",
  stroke: "#D6D8D8",
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M138.79 245.116H91.52v3.924h47.27v-3.924ZM129.474 251.886H91.52v3.924h37.954v-3.924ZM133.691 259.245H91.52v3.924h42.171v-3.924ZM183.903 245.116h-35.208v3.924h35.208v-3.924ZM193.023 251.886h-44.328v3.924h44.328v-3.924ZM187.041 259.245h-38.346v3.924h38.346v-3.924Z",
  fill: "#ECEFF0"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M144.576 245.116v17.759",
  stroke: "#151415",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "m84.165 227.847 6.08-5.298 5.1 10.498 15.201-20.408 6.374 11.087 24.714-31.201 8.925 2.649 12.945.589 13.044-1.178 13.337-17.857",
  stroke: "#0C75D7",
  strokeMiterlimit: 10
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "m84.165 221.175 7.551 1.766 16.966-1.766 6.081 2.747 15.397-4.415 9.022-5.495 9.317 7.457 3.727 2.453 3.825 10.499 9.611-16.778 7.747.294 9.513 3.827 6.963-3.042",
  stroke: "#D6D8D8",
  strokeMiterlimit: 10
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M154.874 198.608c4.766 0 8.63-3.866 8.63-8.634 0-4.769-3.864-8.635-8.63-8.635-4.766 0-8.63 3.866-8.63 8.635 0 4.768 3.864 8.634 8.63 8.634Z",
  stroke: "#FF9650",
  strokeWidth: 0.75,
  strokeMiterlimit: 10
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M79.751 239.817h115.332",
  stroke: "#151415",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "m328.166 95.193 16.77-15.012-1.667 22.469-15.103-7.457Z",
  fill: "#FF9650"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "m296.783 195.861-13.926-6.868-1.471 2.943c-.883 1.865-.197 4.121 1.765 5.004l7.159 3.533c1.863.883 4.119.196 5.002-1.767l1.471-2.845Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "m343.321 102.638-15.141-7.44-43.629 88.862 15.141 7.441 43.629-88.863Z",
  fill: "#0C75D7"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "m333.069 97.547-43.642 88.895M338.365 100.197l-43.544 88.796",
  stroke: "#000",
  strokeMiterlimit: 10
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "m299.681 191.471-15.14-7.44-2.638 5.372 15.141 7.441 2.637-5.373Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "m340.032 84.498 4.904-4.317-.491 6.475-4.413-2.158Z",
  fill: "#000"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M235.205 229.437 185.093 53.042l-24.905 7.082 50.113 176.395 24.904-7.082Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "m170.173 57.221 50.114 176.415M176.253 55.553l50.115 176.415M165.269 58.595l50.115 176.513M178.117 61.342l-16.084 4.513M163.602 71.35l16.084-4.513M181.255 72.331l-16.084 4.612M182.824 77.826l-16.182 4.611M184.393 83.418l-16.182 4.514M185.962 88.913l-16.181 4.612M187.531 94.408l-16.181 4.611M189.1 99.902l-16.181 4.612M190.67 105.495l-16.182 4.513M192.239 110.99l-16.182 4.611M193.808 116.484l-16.182 4.611M195.377 121.979l-16.182 4.611M196.946 127.571l-16.182 4.514M198.515 133.066l-16.181 4.611M200.085 138.56l-16.182 4.612M201.654 144.055l-16.182 4.611M203.223 149.648l-16.182 4.513M204.792 155.142l-16.182 4.612M206.361 160.637l-16.182 4.611M207.93 166.131l-16.181 4.612M209.499 171.724l-16.181 4.513M211.068 177.219l-16.181 4.611M212.638 182.713l-16.182 4.612M214.207 188.208l-16.182 4.611M215.776 193.8l-16.182 4.514M217.247 199.295l-16.084 4.611M218.816 204.79l-16.084 4.611M220.385 210.284l-16.083 4.612M221.954 215.877l-16.083 4.513M223.524 221.371l-16.084 4.612M225.093 226.866l-16.084 4.611M186.747 58.89l-3.531.98M188.316 64.384l-2.158.588M191.454 75.373l-2.157.588M189.885 69.878l-2.157.589M195.377 89.207l-2.158.589M198.515 100.295l-2.157.588M196.946 94.702l-2.157.589M202.046 112.952l-2.06.588M205.184 124.039l-2.059.589M203.615 118.446l-2.059.589M208.617 136.107l-2.06.589M211.755 147.195l-2.059.589M210.186 141.602l-2.06.589M215.384 159.852l-2.06.589M218.522 170.841l-2.06.589M216.953 165.346l-2.06.589M222.249 183.792l-2.158.589M225.289 194.782l-2.06.588M223.72 189.287l-2.06.589M228.917 207.537l-2.059.589M232.056 218.526l-2.06.589M230.486 213.031l-2.059.589M220.287 177.12l-3.53.982M233.723 224.413l-3.531.981M200.183 106.182l-3.531.981M227.054 200.767l-3.531.981M213.618 153.474l-3.53.981M193.416 82.535l-3.531.982M206.851 129.828l-3.53.981",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "m290.305 77.298-15.417-2.928-5.341 28.149 15.417 2.928 5.341-28.15Z",
  fill: "#455A64"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M298.352 77.531c1.373-7.947-3.923-15.404-11.867-16.778-7.944-1.373-15.397 3.925-16.77 11.873-1.275 7.555 3.53 14.717 10.788 16.581l-1.569 9.125 13.926 2.355 2.255-13.344-2.746-.49c3.041-2.06 5.296-5.397 5.983-9.322Z",
  fill: "#B78876",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M280.699 80.377c-.294.785-1.373 1.177-2.452.785-1.079-.393-1.765-1.276-1.471-2.06 0-.099 0-.099.098-.197",
  fill: "#B78876"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M280.699 80.377c-.294.785-1.373 1.177-2.452.785-1.079-.393-1.765-1.276-1.471-2.06 0-.099 0-.099.098-.197",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M282.17 89.305s2.256.393 3.727.197l-3.727-.197Z",
  fill: "#B78876"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M282.17 89.305s2.256.393 3.727.197",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "m279.914 69.584-3.824 5.298 1.765 1.472",
  fill: "#B78876"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "m279.914 69.584-3.824 5.298 1.765 1.472",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "m269.42 191.936 21.478 79.083h34.031v-35.323l-55.509-43.76Z",
  fill: "#B78876",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "m260.79 198.216-15.887 72.803h33.638l31.285-74.962-49.036 2.159ZM302.176 103.532l33.933 31.398c3.334 3.042 5.197 7.457 5.197 11.97 0 4.219-1.569 8.242-4.511 11.284L316.2 176.139s6.865 12.756-3.236 12.756l-4.119-14.816 13.926-25.216-18.143-15.699-2.452-29.632Z",
  fill: "#B78876",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M263.83 171.528h43.446s19.81 25.02 19.81 76.727l-78.359-2.453 15.103-74.274Z",
  fill: "#FF9650"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M307.276 171.528H263.83l-5.786-52.787c-1.275-11.382 7.65-21.39 19.124-21.39h10.886c10.69 0 19.32 8.634 19.32 19.329v54.848h-.098Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M278.639 61.636c1.471 3.533 5.394 9.91 13.338 13.835l-.981 21.39c-.392 4.807 3.531 8.83 8.336 8.438 4.707-.295 8.042-4.612 7.061-9.224-1.373-6.966-3.334-16.581-5.296-23.057-3.04-10.302-15.985-17.367-21.673-13.835-.883.491-1.177 1.57-.785 2.453Z",
  fill: "#455A64"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M290.898 77.63c.392 0 .882 0 1.275.098 2.452.392 4.315 2.158 4.021 3.728-.295 1.668-2.55 2.65-5.002 2.257-.981-.197-1.765-.49-2.452-.981",
  fill: "#B78876"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M290.898 77.63c.392 0 .882 0 1.275.098 2.452.392 4.315 2.158 4.021 3.728-.295 1.668-2.55 2.65-5.002 2.257-.981-.197-1.765-.49-2.452-.981",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "m259.907 107.948-19.81 37.088-45.309 4.71v8.536h44.721c6.963 0 13.533-2.747 18.437-7.653l11.867-11.872c9.316-9.322 5.786-25.118-6.669-29.534l-3.237-1.275Z",
  fill: "#B78876",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "m192.827 162.599-5.59.981c-.883.196-1.668-.294-1.962-1.177-.196-.883.294-1.668 1.177-1.963l4.119-.686-5.688 1.079c-.883.196-1.667-.294-1.961-1.177-.197-.884.294-1.668 1.176-1.963l5.002-.883v-.098l-6.571 1.276c-.882.196-1.667-.295-1.961-1.178-.196-.883.294-1.668 1.177-1.962l7.257-1.472v-.098l-5.296.981c-.883.196-1.667-.294-1.961-1.177-.196-.883.294-1.668 1.177-1.963l5.197-.883-3.53-2.355c-.687-.49-.785-.981-.196-1.962.49-.785 1.961-.49 3.236-.098l6.277.687 5.295 1.962 2.256 9.419c0 .295-8.63 4.71-8.63 4.71Z",
  fill: "#B78876",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "m198.417 149.255 2.059.687 1.667 7.555-2.353.589-1.373-8.831Z",
  fill: "#B78876"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "m328.166 95.193 16.77-15.012-1.667 22.469-15.103-7.457Z",
  fill: "#FF9650"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "m296.783 195.861-13.926-6.868-1.471 2.943c-.883 1.865-.197 4.121 1.765 5.004l7.159 3.533c1.863.883 4.119.196 5.002-1.767l1.471-2.845Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "m343.321 102.638-15.141-7.44-43.629 88.862 15.141 7.441 43.629-88.863Z",
  fill: "#0C75D7"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "m333.069 97.547-43.642 88.895M338.365 100.197l-43.544 88.796",
  stroke: "#000",
  strokeMiterlimit: 10
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "m299.681 191.471-15.14-7.44-2.638 5.372 15.141 7.441 2.637-5.373Z",
  fill: "#ECEFF0",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "m340.032 84.498 4.904-4.317-.491 6.475-4.413-2.158Z",
  fill: "#000"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M275.796 69.78a.784.784 0 1 0 0-1.569.784.784 0 0 0 0 1.57ZM283.935 74.097a.785.785 0 1 0 0-1.57.785.785 0 0 0 0 1.57Z",
  fill: "#151415"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M287.574 62.158c.646-.493.423-1.87-.497-3.076-.921-1.206-2.191-1.783-2.836-1.29-.646.493-.423 1.87.498 3.077.92 1.205 2.19 1.783 2.835 1.29ZM293.037 69.34c.646-.493.29-2.045-.795-3.466-1.085-1.421-2.488-2.173-3.134-1.68-.645.493-.289 2.045.796 3.466 1.085 1.422 2.488 2.174 3.133 1.68Z",
  fill: "#fff",
  stroke: "#151415",
  strokeMiterlimit: 10
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "m287.564 62.127 1.569 2.06M292.762 77.63l.294-8.242",
  stroke: "#151415",
  strokeMiterlimit: 10
});

function SvgGraphLoadingData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362 271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLoadingData);
export default __webpack_public_path__ + "static/media/graph-loadingData.c1b3b7cc3ac77f05e7d9b1f2797c9df0.svg";
export { ForwardRef as ReactComponent };